module.exports = __webpack_public_path__ + "static/media/rocheharold.b4cef4c6.pdf";